<template>
    <div dir="rtl" class="mr-8 px-4 sm:px-6 lg:px-8">
        <div class="sm:flex sm:items-center">
            <div class="sm:flex-auto">
                <h1 class="text-xl font-semibold text-gray-900">جلسات الدارسين</h1>
                <p class="mt-2 text-sm text-gray-700"></p>
            </div>
        </div>

        <div class="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-4">
            <div>
                <label class="block text-sm font-medium text-gray-700">التاريخ</label>
                <input
                    type="date"
                    v-model="dateOfSearch"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
            </div>

            <div>
                <label class="block text-sm font-medium text-gray-700">الجدول</label>
                <select
                    v-model="selectedScheduleId"
                    @change="handleScheduleChange"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
                    <option value="">كل الجداول</option>
                    <option v-for="s in scheduleOptions" :key="s.id" :value="s.id">{{ s.title }}</option>
                </select>
            </div>

            <div>
                <label class="block text-sm font-medium text-gray-700">المعلم</label>
                <select
                    v-model="selectedTeacherId"
                    :disabled="!selectedScheduleId || teachersLoading"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm disabled:bg-gray-100 disabled:text-gray-400">
                    <option value="">{{ selectedScheduleId ? 'كل المعلمين' : 'اختر الجدول أولاً' }}</option>
                    <option v-for="t in teacherOptions" :key="t.id" :value="t.id">{{ t.name }}</option>
                </select>
            </div>

            <div class="flex items-end gap-2">
                <button class="button" type="submit" @click="getAllSessions()">بحث</button>
                <button class="reset-button" type="button" @click="resetFilters()">إعادة تعيين</button>
            </div>
        </div>


        <div class="mt-8 flex flex-col">
            <div class="sm:flex-auto">
                <h1 class="text-lg font-medium text-gray-900"> الجلسات</h1>
                <p class="mt-2 text-xs text-gray-700"></p>
            </div>
            <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                    <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                        <table class="min-w-full divide-y divide-customHafadhColor">
                            <thead class="bg-customHafadhColor text-center">
                                <tr>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        الاسم
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        الايميل
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        الجدول
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        المعلم
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        حالة الحضور للجلسة
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        تاريخ الجلسة
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        التسجيل الصوتي
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 bg-white">
                                <tr v-for="(student, index) in students" :key="index">
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        {{ student.fullName }}
                                    </td>
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        {{ student.email }}
                                    </td>
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        {{ student.scheduleTitle || '—' }}
                                    </td>
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        {{ student.teacherName || '—' }}
                                    </td>
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        {{ student.hasAttendedSessionToday == true ? "حاضر" : "غائب" }}
                                    </td>
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        {{ dateOfSearch }}
                                    </td>
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        <button v-if="student.hasAttendedSessionToday" class="enabled-button" @click="openPopup(index, student.id)">
                                            التسجيل</button>
                                        <span v-else class="text-xs text-gray-400">لا يوجد تسجيل</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- Audio Popup -->
        <div v-if="showPopup" class="popup" dir="rtl">
            <div class="popup-content">
                <h3 class="text-lg leading-6 font-medium text-gray-900">الاستماع للتسجيل</h3>
                <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">

                    <div class="col-span-2">
                        <div v-for="(item, index) in audioSources" :key="index" class="mb-4">
                            <p v-if="audioSources.length > 1" class="mb-2 text-sm text-gray-600 font-bold">التسجيل {{ index + 1 }}</p>
                            <AudioPlayer :src="item.src" :is-hls="item.isHls" crossorigin="anonymous" />
                        </div>
                    </div>

                    <button
                        class="close mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                        @click="closePopup" type="button">اغلاق</button>

                </div>
            </div>
        </div>

        <!-- Error/Warning Modal -->
        <transition name="modal-fade">
            <div v-if="showErrorModal" class="fixed inset-0 z-50 overflow-y-auto" dir="rtl" @click.self="closeErrorModal">
                <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                    <!-- Background overlay -->
                    <div class="fixed inset-0 transition-opacity bg-gray-900 bg-opacity-50 backdrop-blur-sm"></div>

                    <!-- Modal panel -->
                    <div class="inline-block align-bottom bg-white rounded-2xl text-right overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                        <!-- Header with gradient -->
                        <div class="bg-gradient-to-r from-yellow-50 to-orange-50 px-6 py-4 border-b border-yellow-200">
                            <div class="flex items-center">
                                <div class="flex-shrink-0 flex items-center justify-center h-14 w-14 rounded-full bg-yellow-100 shadow-md">
                                    <svg class="h-8 w-8 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                    </svg>
                                </div>
                                <div class="mr-4 flex-1">
                                    <h3 class="text-xl font-bold text-gray-900" id="modal-title">
                                        تنبيه
                                    </h3>
                                    <p class="text-sm text-gray-600 mt-1">يرجى مراجعة المعلومات التالية</p>
                                </div>
                                <button
                                    @click="closeErrorModal"
                                    class="text-gray-400 hover:text-gray-600 transition-colors duration-200">
                                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <!-- Content -->
                        <div class="bg-white px-6 py-5">
                            <div class="mt-2">
                                <p class="text-base text-gray-700 whitespace-pre-line leading-relaxed">
                                    {{ errorMessage }}
                                </p>
                                <div v-if="errorData && (errorData.studentName || errorData.date)" class="mt-5 p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl border border-gray-200">
                                    <div class="space-y-2">
                                        <div v-if="errorData.studentName" class="flex items-center">
                                            <svg class="h-5 w-5 text-gray-500 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                            </svg>
                                            <span class="text-sm text-gray-600">الطالب:</span>
                                            <strong class="text-sm text-gray-900 mr-2">{{ errorData.studentName }}</strong>
                                        </div>
                                        <div v-if="errorData.date" class="flex items-center">
                                            <svg class="h-5 w-5 text-gray-500 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            </svg>
                                            <span class="text-sm text-gray-600">التاريخ:</span>
                                            <strong class="text-sm text-gray-900 mr-2">{{ errorData.date }}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Footer -->
                        <div class="bg-gray-50 px-6 py-4 sm:flex sm:flex-row-reverse border-t border-gray-200">
                            <button
                                type="button"
                                @click="closeErrorModal"
                                class="w-full inline-flex justify-center items-center rounded-xl border border-transparent shadow-lg px-6 py-3 bg-gradient-to-r from-customHafadhColor to-customHafadhColor/90 text-base font-semibold text-white hover:from-customHafadhColor/90 hover:to-customHafadhColor transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-customHafadhColor sm:mr-3 sm:w-auto sm:text-sm transform hover:scale-105">
                                <svg class="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                </svg>
                                موافق
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import url from '@/url';
import axios from 'axios';
import { defineComponent } from 'vue';
import AudioPlayer from './AudioPlayer.vue';
import { listIqraSchedules, listIqraSlotTeachers } from '@/services/iqraSchedules';


class StudentDto {
    constructor(data) {
        this.id = data.id || null;
        this.email = data.email || null;
        this.fullName = data.fullName || null;
        this.engagementPreference = data.engagementPreference || null;
        this.qualificationValue = data.qualificationValue || null;
        this.canWithdraw = data.canWithdraw || false;
        this.isEnabled = data.isEnabled || false;
        this.phone = data.phone || false;
        this.massaratValue = data.massaratValue || null;
        this.hasAttendedSessionToday = data.hasAttendedSessionToday || null;
        this.teacherName = data.teacherName || null;
        this.scheduleTitle = data.scheduleTitle || null;
    }
}
export default defineComponent({
    components: {
        AudioPlayer
    },
    data() {
        return {
            students: [],
            showPopup: false,
            userIndex: '',
            dateOfSearch: "",
            audioSources: [],
            fullName: "",
            showErrorModal: false,
            errorMessage: "",
            errorData: null,
            scheduleOptions: [],
            teacherOptions: [],
            selectedScheduleId: "",
            selectedTeacherId: "",
            teachersLoading: false,
        }
    },
    async mounted() {
        this.dateOfSearch = this.formattedDate(new Date());
        await this.loadScheduleOptions();
        this.getAllSessions();
    },
    methods: {
        async getAllSessions() {
            try {
                const response = await axios.get(process.env.VUE_APP_SERVICE_URL + url.get_students_sessions + this.dateOfSearch,
                    {
                        headers: {
                            'X-Authorization': localStorage.getItem('token'),
                        },
                        params: {
                            ...(this.selectedScheduleId ? { scheduleId: this.selectedScheduleId } : {}),
                            ...(this.selectedTeacherId ? { teacherId: this.selectedTeacherId } : {}),
                        },
                    },
                );
                this.students = response.data.result.data.map(studentData => new StudentDto(studentData));
            } catch (error) {
                console.error(error);
            }
        },
        async loadScheduleOptions() {
            try {
                const result = await listIqraSchedules({ is_active: true, page: 1, size: 100 });
                const data = result?.data ?? [];
                this.scheduleOptions = (Array.isArray(data) ? data : []).map((s) => ({
                    id: String(s.id),
                    title: s.title || `جدول #${s.id}`,
                }));
            } catch (error) {
                console.error('Error loading schedules:', error);
                this.scheduleOptions = [];
            }
        },
        async handleScheduleChange() {
            // Teacher list belongs to the chosen schedule; reset to "all teachers".
            this.selectedTeacherId = "";
            this.teacherOptions = [];
            if (!this.selectedScheduleId) {
                this.getAllSessions();
                return;
            }

            this.teachersLoading = true;
            try {
                const rows = await listIqraSlotTeachers({
                    schedule_id: this.selectedScheduleId,
                    is_active: true,
                });
                const list = Array.isArray(rows) ? rows : (rows?.data ?? []);
                // A schedule has many slot-teacher rows; collapse to a distinct teacher list.
                const seen = new Map();
                list.forEach((row) => {
                    if (row.teacher_id == null) return;
                    const id = String(row.teacher_id);
                    if (!seen.has(id)) {
                        seen.set(id, { id, name: row.teacher_name || `معلم #${id}` });
                    }
                });
                this.teacherOptions = Array.from(seen.values());
            } catch (error) {
                console.error('Error loading teachers for schedule:', error);
                this.teacherOptions = [];
            } finally {
                this.teachersLoading = false;
            }
            this.getAllSessions();
        },
        resetFilters() {
            this.selectedScheduleId = "";
            this.selectedTeacherId = "";
            this.teacherOptions = [];
            this.dateOfSearch = this.formattedDate(new Date());
            this.getAllSessions();
        },
        openPopup(index, studentId) {
            this.getStudentsDownload(studentId);
            this.userIndex = index;
        },
        closePopup() {
            this.showPopup = false;
            if (this.audioSources && this.audioSources.length > 0) {
                this.audioSources.forEach(item => {
                    const src = item?.src;
                    if (src && src.startsWith('blob:')) URL.revokeObjectURL(src);
                });
                this.audioSources = [];
            }
        },
        formattedDate(date) {
            if (date != null && date != undefined && date != "") {
                const dateObj = date instanceof Date ? date : new Date(date);
                if (isNaN(dateObj.getTime())) {
                    return '';
                }
                const year = dateObj.getFullYear();
                const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
                const day = dateObj.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${day}`;
            }
            return '';
        },
        async getStudentsDownload(studentId) {
            try {
                const infoUrl = `${process.env.VUE_APP_SERVICE_URL}/api/v1/admin/get-recordings-info/${studentId}/date/${this.dateOfSearch}`;
                const infoResponse = await axios.get(infoUrl, {
                    headers: { 'X-Authorization': localStorage.getItem('token') }
                });

                const recordingIds = infoResponse.data.result.data || [];

                if (recordingIds.length === 0) {
                    this.showError('لا يوجد تسجيل للجلسة', null);
                    return;
                }

                if (this.audioSources && this.audioSources.length > 0) {
                    this.audioSources.forEach(item => {
                        const src = item?.src;
                        if (src && src.startsWith('blob:')) URL.revokeObjectURL(src);
                    });
                }
                this.audioSources = [];

                // Fetch each recording stream.
                // Backend returns either:
                //   - raw audio (legacy .aac) — Content-Type: audio/aac
                //   - rewritten HLS manifest text — Content-Type: application/vnd.apple.mpegurl
                //     (segments inside already point at presigned absolute S3 URLs)
                // We mark HLS sources so the player can hand them to hls.js instead of
                // dropping them into a plain <audio src>.
                for (const id of recordingIds) {
                    const streamUrl = `${process.env.VUE_APP_SERVICE_URL}/api/v1/admin/stream-recording/${studentId}/date/${this.dateOfSearch}?recordingId=${id}`;

                    const response = await axios.get(streamUrl, {
                        headers: { 'X-Authorization': localStorage.getItem('token') },
                        responseType: 'blob',
                        timeout: 30000,
                    });

                    const contentType = response.data?.type || response.headers['content-type'] || '';
                    const isHls = contentType.includes('application/vnd.apple.mpegurl') || contentType.includes('audio/x-mpegurl');
                    this.audioSources.push({
                        src: URL.createObjectURL(response.data),
                        isHls,
                    });
                }

                this.showPopup = true;
            } catch (error) {
                console.error('Error fetching/streaming recording:', error);

                let errorMessage = 'حدث خطأ في جلب التسجيل';
                let errorData = null;

                if (error.response && error.response.data) {
                    const responseData = error.response.data;
                    if (responseData.result) {
                        errorMessage = responseData.result.mesAr || responseData.result.mesEn || errorMessage;
                        errorData = responseData.result.data || null;
                    } else if (responseData.messageAr) {
                        errorMessage = responseData.messageAr;
                    } else if (responseData.message) {
                        errorMessage = responseData.message;
                    }
                } else if (error.message) {
                    errorMessage = error.message;
                }

                this.showError(errorMessage, errorData);
            }
        },
        showError(message, data = null) {
            this.errorMessage = message;
            this.errorData = data;
            this.showErrorModal = true;
        },
        closeErrorModal() {
            this.showErrorModal = false;
            this.errorMessage = "";
            this.errorData = null;
        }
    }
})
</script>

<style scoped>
.enabled-button {
    @apply px-4 py-2 bg-customHafadhColor text-white rounded hover:bg-customHafadhColor w-20 h-10;
}

.disabled-button {
    @apply px-4 py-2 bg-gray-300 text-gray-500 rounded cursor-not-allowed w-20 h-10;
}

.popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    width: 580px;
    max-width: 92vw;
    max-height: 90vh;
    overflow-y: auto;
    box-sizing: border-box;
    text-align: center;
}

.button {
    @apply px-4 py-2 bg-customHafadhColor text-white rounded hover:bg-customHafadhColor w-20 h-10;
}

.reset-button {
    @apply px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 h-10 whitespace-nowrap;
}

.close {
    margin-top: 50%;
    margin-right: 50%;
}

/* Modal transitions */
.modal-fade-enter-active, .modal-fade-leave-active {
    transition: opacity 0.3s ease;
}

.modal-fade-enter-from, .modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active .inline-block,
.modal-fade-leave-active .inline-block {
    transition: transform 0.3s ease;
}

.modal-fade-enter-from .inline-block,
.modal-fade-leave-to .inline-block {
    transform: scale(0.95) translateY(-20px);
}
</style>
